// extracted by mini-css-extract-plugin
export var cartContainer = "_nd-4";
export var gray = "_nd-1";
export var itemContainer = "_nd-2";
export var itemDetails = "_nd-3";
export var strong = "_nd-0";